<template>
  <div class="tab">
    <h3>项目整体构想</h3>
    <div>
      <h4>总体研究框架：</h4>
      <img src="../../assets/framework.png" alt />
      <h4>主要研究问题：</h4>
      <span>如何从“全人”的角度认识流动背景下处境不利儿童青少年？</span>
      <span>如何开展中国文化下儿童青少年积极发展的研究？</span>
      <span>如何开展我国文化背景下儿童青少年积极发展的指标体系及其测量工具的完整性研究？</span>
      <span>如何构建起促进处境不利儿童青少年积极发展的多元化综合体系？</span>
      <h4>中国儿童青少年积极发展体系的构建：</h4>
      <p>本课题采用自上而下（已有青少年积极发展的理论）与自下而上（元分析、访谈研究、全国代表性调查以及追踪研究等）相结合的整合型研究思路，初步构建促进流动背景下处境不利儿童青少年积极发展的“ 研究—政策—实践”三位一体的综合体系，并提出我国流动背景下处境不利儿童青少年积极发展促进体系的指导框架（见图 10）。切实找出我国文化背景下契合流动儿童和留守儿童人群特点的重要、核心的、 可被干预与改变的个体促进性因素以及诸多环境促进性因素（包括家庭、学校和社区因素等）；并从政策、实践应用等多方面产出系统的促进流动儿童和留守儿童积极发展的政策报告和实践干预指南。</p>
      <img src="../../assets/indicators.png" alt />
    </div>
  </div>
</template>
<script>
export default {
  name: "wholeIdea",
  data() {
    return {};
  }
};
</script>
<style scoped src="../../assets/style/grandchild.css">
/* @import '../assets/style/child.css'; */
</style>
<style scoped>
.tab > div > span {
  display: block;
  font-size: 20px;
  color: #070707;
  line-height: 1.5;
  text-indent: 2em;
  font-family: serif;
}
</style>



// WEBPACK FOOTER //
// src/components/tabs/wholeIdea.vue